module.exports = __webpack_public_path__ + "static/img/Basics.4c8004b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Basics.png
// module id = v98y
// module chunks = 3